import React, { useState } from 'react';
import BottomNavigation from '../../../components/molecule/bottomNavigation/BottomNavigation';
const imageBackground = '/images/home/common/primaryGirl/dummyImage.jpg';
const imageBackgroundMobile =
  '/images/home/common/primaryGirl/dummyImageMobile.jpg';

import styles from './MajorTemplate.module.scss';
import Text from '../../atoms/text/Text';
import TextWithSvg from '../../molecule/textWithSvg/TextWithSvg';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useIsRtl from '../../../app/helpers/isRtl';
const time = '/assets/svg/majorDetails/time.svg';
const calendar = '/assets/svg/majorDetails/calendar.svg';
const student = '/assets/svg/majorDetails/student.svg';
const language = '/assets/svg/majorDetails/language.svg';

function getLanguageText(languageCode, currentLanguage) {
  switch (languageCode) {
    case 0:
      return currentLanguage === 'en' ? 'English' : 'الإنجليزية';
    case 1:
      return currentLanguage === 'en' ? 'Arabic' : 'العربية';
    case 2:
      return currentLanguage === 'en'
        ? 'Arabic And English'
        : 'العربية و الإنجليزية';
    case 3:
      return currentLanguage === 'en' ? 'Arabic' : 'العربية';
    default:
      return 'English';
  }
}
function MajorTemplate({ handleButtonClick, navigationData, data }) {
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = useIsRtl();
  const [bgImage] = useState(imageBackground);
  return (
    <>
      <div className={styles['major-container']}>
        <img
          className={styles.images}
          src={isMobile ? imageBackgroundMobile : imageBackground}
        />
        <div className={styles.backdrop}></div>
        <BottomNavigation
          data={navigationData}
          variant="text-bold-20"
          onClick={handleButtonClick}
          active={1}
          isApplyNow
        />
        <div className={styles['major-heading']}>
          <div className={`${styles['heading']} ${isRtl ? 'rtl' : ''}`}>
            <div className={styles['text']}>
              <Text
                title={data?.degree?.degreeNameAr}
                variant="text-bold-italic-40"
                style={{ textTransform: 'uppercase' }}
              />
              {/* <Text
                title="LaW AND POLICE SCIENCES"
                variant="text-bold-italic-25"
                style={{ textTransform: 'uppercase' }}
              /> */}
            </div>
            <div className={styles['grid']}>
              <TextWithSvg
                svg={student}
                text="Major.entry_level"
                subText={data?.degree?.entryLevelAr}
                variant="text-regular-20"
                subTextVariant={'text-bold-20-black'}
                imgStyle={styles.image}
                style={{ zIndex: 1 }}
                textTransformState="capitalized"
                titleClassname={styles.titleClass}
              />
              <TextWithSvg
                svg={calendar}
                text="Major.Credit_Hours"
                subText={data?.degree?.creditHours}
                variant="text-regular-20"
                subTextVariant={'text-bold-20-black'}
                imgStyle={styles.image}
                style={{ zIndex: 1 }}
                textTransformState="capitalized"
                titleClassname={styles.titleClass}
              />
              <TextWithSvg
                svg={time}
                text="Major.Duration"
                subText={data?.degree?.durationAr}
                variant="text-regular-20"
                subTextVariant={'text-bold-20-black'}
                imgStyle={styles.image}
                style={{ zIndex: 1 }}
                type="email"
                textTransformState="capitalized"
                titleClassname={styles.titleClass}
              />
              <TextWithSvg
                svg={language}
                text="Major.Language"
                subText={getLanguageText(
                  data?.degree?.languages,
                  currentLanguage
                )}
                variant="text-regular-20"
                subTextVariant={'text-bold-20-black'}
                imgStyle={styles.image}
                style={{ zIndex: 1 }}
                textTransformState="capitalized"
                titleClassname={styles.titleClass}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MajorTemplate;
